"use strict";
/*
 * Created on 24. 4. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Type of release export.
 * @author Radek Beran
 */

var ReleaseExportType;

(function (ReleaseExportType) {
  /** Export of regular prices. */
  ReleaseExportType["Regular"] = "Regular";
  /** Export of regular site prices. */

  ReleaseExportType["RegularSite"] = "RegularSite";
  /** Export of sellout prices. */

  ReleaseExportType["Sellout"] = "Sellout";
  /** Export of end date trimming changes for exhausted sellout supplies or manually ended sellout prices. */

  ReleaseExportType["SelloutEndDateTrim"] = "SelloutEndDateTrim";
  /** Export of end date trimming changes for site releases. */

  ReleaseExportType["SiteReleaseEndDateTrim"] = "SiteReleaseEndDateTrim";
})(ReleaseExportType = exports.ReleaseExportType || (exports.ReleaseExportType = {}));